module.exports = __webpack_public_path__ + "static/media/QD.65eeeb43.svg";